var map = {
	"./1/1.svg": 31579,
	"./1/2.svg": 80840,
	"./1/3.svg": 46233,
	"./1/4.svg": 89846,
	"./1/5.svg": 70023,
	"./1/6.svg": 5460,
	"./1/7.svg": 78069,
	"./1/8.svg": 23954,
	"./1/9.svg": 38595,
	"./2/1.svg": 43100,
	"./2/2.svg": 22127,
	"./2/3.svg": 59550,
	"./2/4.svg": 84833,
	"./2/5.svg": 72592,
	"./2/6.svg": 17731,
	"./2/7.svg": 79794,
	"./2/8.svg": 3285,
	"./2/9.svg": 61300,
	"./3/1.svg": 81157,
	"./3/2.svg": 61286,
	"./3/3.svg": 7735,
	"./3/4.svg": 12664,
	"./3/5.svg": 88169,
	"./3/6.svg": 62586,
	"./3/7.svg": 67851,
	"./3/8.svg": 36524,
	"./3/9.svg": 88333,
	"./4/1.svg": 47702,
	"./4/2.svg": 60661,
	"./4/3.svg": 15732,
	"./4/4.svg": 47355,
	"./4/5.svg": 5386,
	"./4/6.svg": 31385,
	"./4/7.svg": 65992,
	"./4/8.svg": 24143,
	"./4/9.svg": 61566,
	"./5/1.svg": 37199,
	"./5/2.svg": 34876,
	"./5/3.svg": 63421,
	"./5/4.svg": 29490,
	"./5/5.svg": 32803,
	"./5/6.svg": 27056,
	"./5/7.svg": 18177,
	"./5/8.svg": 60758,
	"./5/9.svg": 23975,
	"./6/1.svg": 80304,
	"./6/2.svg": 37347,
	"./6/3.svg": 22706,
	"./6/4.svg": 56637,
	"./6/5.svg": 67164,
	"./6/6.svg": 46191,
	"./6/7.svg": 2462,
	"./6/8.svg": 44985,
	"./6/9.svg": 79592
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34978;